{
  "hero": {
    "title": "あなたの製品カタログを",
    "subtitle": "AIショッピングアドバイザーに変える",
    "description": "単なるチャットではなく、販売する会話型の営業力を配備。あなたのウェブサイト、ソーシャルメディア、WhatsApp、ChatGPTで。",
    "createAssistant": "AIアシスタントを作成",
    "bookDemo": "デモを予約"
  },
  "nav": {
    "solutions": "ソリューション",
    "products": "製品",
    "pricing": "価格",
    "caseStudies": "事例研究",
    "blog": "ブログ",
    "contact": "お問い合わせ",
    "shoppingExpert": "ショッピングエキスパート",
    "gptStore": "GPTストア"
  },
  "chat": {
    "greeting": "こんにちは！AIショッピングアシスタントです。テレビ、ノートパソコン、コーヒーメーカーなどの製品について質問してみてください。今日はどのようにお手伝いできますか？",
    "placeholder": "メッセージを入力してください...",
    "contact": {
      "heading": "お問い合わせ情報を共有してください"
    }
  },
  "sections": {
    "partners": {
      "title": "主要プラットフォームから信頼されています"
    },
    "gptPromo": {
      "title": "GPTストアであなたのブランドを立ち上げる",
      "description": "あなたの製品を紹介し、閲覧者を購入者に変えるカスタムGPTショッピングアシスタントを作成しましょう。"
    },
    "solutions": {
      "title": "業界別ソリューション",
      "subtitle": "あなたの業界に合わせたAIショッピングアドバイザー",
      "electronics": {
        "title": "家電製品とテクノロジー",
        "description": "顧客が複雑な技術仕様をナビゲートし、完璧なデバイスを見つけるのを支援します。",
        "items": [
          "スマートな製品比較",
          "技術仕様のマッチング",
          "互換性チェック",
          "パフォーマンス推奨"
        ]
      },
      "fashion": {
        "title": "ファッションとアパレル",
        "description": "パーソナライズされたスタイリングアドバイスとサイズ推奨を提供します。",
        "items": [
          "スタイルのマッチングと推奨",
          "サイズとフィットのガイダンス",
          "季節のトレンドアドバイス",
          "コーディネート提案"
        ]
      },
      "home": {
        "title": "ホーム＆ガーデン",
        "description": "顧客が住宅改善や装飾の決定をするためのガイドを提供します。",
        "items": [
          "部屋のデザインコンサルテーション",
          "家電製品の推奨",
          "スペース最適化アドバイス",
          "メンテナンスガイダンス"
        ]
      },
      "agency": {
        "title": "代理店とパートナー",
        "description": "複数の小売クライアントにサービスを提供する代理店向けのホワイトラベルソリューション。",
        "items": [
          "マルチクライアント管理",
          "カスタムブランディングオプション",
          "分析とレポート",
          "代理店パートナーサポート"
        ]
      }
    },
    "platforms": {
      "title": "対応プラットフォーム"
    },
    "valueProps": {
      "title": "なぜShopilots を選ぶのか？",
      "subtitle": "実際に販売するAIであなたの小売体験を変革",
      "conversion": {
        "title": "コンバージョン率の向上",
        "description": "パーソナライズされた製品推奨とガイド付きショッピング体験で、閲覧者を購入者に変えます。",
        "metric": "コンバージョン率"
      },
      "aov": {
        "title": "平均注文額の増加",
        "description": "顧客に自然で役立つと感じられるスマートなアップセルとクロスセルの提案。",
        "metric": "平均注文額"
      },
      "returns": {
        "title": "返品率の削減",
        "description": "より良い製品マッチングにより、顧客は最初から必要なものを正確に入手できます。",
        "metric": "返品率"
      },
      "advantage": {
        "title": "Shopilotsの優位性",
        "description": "一般的なチャットボットとは異なり、私たちのAIはあなたの製品を理解し、あなたのブランドの声で話します。",
        "features": {
          "catalog": "リアルタイムカタログ統合",
          "sales": "販売重視の会話",
          "channels": "マルチチャネル展開",
          "analytics": "収益主導の分析"
        }
      },
      "testimonial": {
        "title": "顧客の成功事例",
        "quote": "Shopilotsは私たちのオンライン販売を変革しました。顧客はより速く製品を見つけ、より自信を持って購入します。",
        "name": "サラ・ジョンソン",
        "position": "Eコマースディレクター"
      }
    }
  },
  "micro": {
    "demoMode": "デモモード"
  },
  "forms": {
    "name": "名前",
    "email": "メールアドレス",
    "company": "会社名",
    "phone": "電話番号",
    "optional": "任意",
    "thankYou": "ありがとうございます！"
  },
  "buttons": {
    "sending": "送信中...",
    "submit": "送信",
    "launchAssistant": "AIアシスタントを起動",
    "callUs": "お電話ください",
    "learnMore": "詳細を見る",
    "getStarted": "始める",
    "findSolution": "あなたのソリューションを見つける"
  },
  "footer": {
    "description": "単なるチャットではなく、販売するAIショッピングアドバイザー。あなたのウェブサイト、ソーシャルメディア、WhatsApp、ChatGPTで展開。",
    "solutions": "ソリューション",
    "resources": "リソース",
    "contactUs": "お問い合わせ",
    "copyright": "すべての権利を保有。",
    "links": {
      "privacyPolicy": "プライバシーポリシー",
      "termsOfService": "利用規約",
      "sitemap": "サイトマップ"
    }
  }
}